import { styled } from 'styled-components';

const FlexItem = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
`;
export default FlexItem;
